import { render, staticRenderFns } from "./confrontacions.vue?vue&type=template&id=260f957b"
import script from "./confrontacions.vue?vue&type=script&lang=js"
export * from "./confrontacions.vue?vue&type=script&lang=js"
import style0 from "./confrontacions.vue?vue&type=style&index=0&id=260f957b&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports